import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RoleChip } from '@app/features/dashboard/group-list/group-list.utils';

/** Chips de filtro por tipo de usuário, com a contagem, e a legenda Leitura / Gravação à direita. */
@Component({
  selector: 'app-group-role-chips',
  standalone: true,
  templateUrl: './group-role-chips.component.html',
  styleUrls: ['./group-role-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupRoleChipsComponent {
  readonly chips = input<RoleChip[]>([]);
  /** Tipo escolhido (`''` = Todos). */
  readonly selected = input('');
  readonly selectedChange = output<string>();
}
